// extracted by mini-css-extract-plugin
export default {"container":"FloorChangedPopup_container__fz1Fw","icon":"FloorChangedPopup_icon__-2rd+"};